import React from "react";

export default function ButtonGroup(
    {
        options,
        onChange,
        selectedValue,
        name,
        required = false,
        idPrefix = 'control-id-',
        btnGroupAttrs = {},
        labelAttrs = {},
        ...rest
    }
) {

    btnGroupAttrs = {
        className: 'btn-group',
        role: 'group',
        "aria-label": "Title Toggle",
        ...btnGroupAttrs
    };

    labelAttrs = {
        className: 'btn btn-outline-primary',
        ...labelAttrs
    };

    return (
        <div {...btnGroupAttrs}>
            {options?.map((opt,index) =>
                (
                    <React.Fragment key={index}>
                        <input
                            type="radio"
                            className="btn-check"
                            name={name}
                            id={`${idPrefix}-${opt.value}`}
                            autoComplete="off"
                            value={opt.value}
                            checked={opt.value === selectedValue}
                            onChange={onChange}
                            required={required}
                        />

                        <label
                            {...labelAttrs}
                            htmlFor={`${idPrefix}-${opt.value}`}
                        >
                            {opt.label}
                        </label>
                    </React.Fragment>
                )
            )}
        </div>
    );

}